import cmf from '@talend/react-cmf';

const localStorageKey = 'tdc-app';
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const getPreloadedState = (): any => cmf.localStorage.getState(localStorageKey);
const saveUserPreferencesBeforeUnload = cmf.localStorage.getStoreCallback(localStorageKey, [
	['cmf', 'components', 'Container(SidePanel)'],
]);

export { getPreloadedState, saveUserPreferencesBeforeUnload };
